import {
  BusinessCenterRounded,
  ChecklistRtlRounded,
  FlightRounded,
  SchoolRounded,
  WorkHistoryRounded,
} from "@mui/icons-material";
import StarBorderPurple500OutlinedIcon from "@mui/icons-material/StarBorderPurple500Outlined";
import {
  Box, Dialog,
  Paper, Checkbox, DialogContentText, DialogActions, DialogTitle, DialogContent,
  Toolbar,
  Breadcrumbs,
  Card,
  Grid,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
  Divider, FormControlLabel,
  Button,
  Chip,
} from "@mui/material";
import InsertLinkOutlinedIcon from "@mui/icons-material/InsertLinkOutlined";
import React, { useEffect, useRef, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import ResumeContext from "../OptimiseResume/Resumecontext";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { appSelector } from "../redux/selector";
import parse from "html-react-parser";
import DOMPurify from "dompurify";
import moment from "moment";
import { styled, alpha } from "@mui/material/styles";
import LoadingSkeleton from "../loadingSkeletons/LoadingList";
import Loadingjobdetail from "../loadingSkeletons/Loadingjobdetail";
import { myCandidatesSelector } from "./redux/selector";
import { getJobDetailsAction } from "./redux/action";
import StarIcon from "@mui/icons-material/Star";
import Key from "../../clientVariables.json";
import { userSelector } from "../user-redux/selector";
import JobDetailsSkeleton from "./jobDetailSkeleton";
import LaunchIcon from "@mui/icons-material/Launch";
import useAdvancedOptimise from "../AdvancedOptimiseResume/useAdvancedOptimise";
import AdvancedOptimiseAnalysingDialog from "../AdvancedOptimiseResume/AdvancedOptimiseAnalysingDialog";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

// Configure DOMPurify with allowed tags and attributes
const sanitizeConfig = {
  ALLOWED_TAGS: [
    'b', 'i', 'em', 'strong',  // text formatting
    'p', 'br', 'div', 'span',  // block and inline elements
    'ul', 'ol', 'li',          // lists
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6'  // headings
  ],
  ALLOWED_ATTR: ['class', 'id', 'style'], // common styling attributes
  RETURN_DOM: false,
  RETURN_DOM_FRAGMENT: false,
  RETURN_DOM_IMPORT: false,
  SANITIZE_DOM: true,
  KEEP_CONTENT: true,
  FORBID_TAGS: ['script', 'iframe', 'form', 'input', 'style'],
  FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover']
};

// Utility function to safely parse HTML content
const safeParseHTML = (content) => {
  if (!content) return "";
  try {
    const sanitized = DOMPurify.sanitize(content, sanitizeConfig);
    return parse(sanitized);
  } catch (error) {
    console.error('Error parsing HTML content:', error);
    return content;
  }
};



const Bullet = styled("span")({
  display: "inline-block",
  width: "3px",
  height: "3px",
  borderRadius: "50%",
  backgroundColor: "currentColor",
});

const JobDetails = () => {
  const theme = useTheme();
  const isDesktopSmall = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const isDesktopLarge = useMediaQuery(theme.breakpoints.up("lg"));
  const isDesktopMedium = useMediaQuery(
    "(min-width: 1440px) and (max-width: 1919px)"
  );

  const { jobDetails, jobDetailsLoading, candidateJobs, candidateJobsLoading, candidateDetailLoading, candidateInterestedJobsLoading, candidateSubmissions, candidateInterestedJobs, tabView, activeCandidateTab, candidateDetails, candidateResumesList } = useSelector(myCandidatesSelector);
  const { selectedSubmission } = useSelector(appSelector);
  const { user } = useSelector(userSelector);
  const dispatch = useDispatch();
  const [copied, setCopied] = useState(false);
  const [fav, setFav] = useState(false);
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [search, setSearch] = useState("");
  const [companyName, setCompanyName] = useState(null);
  const [favoriteCompanies, setFavoriteCompanies] = useState([]);
  const [favoriteCompaniesSearched, setFavoriteCompaniesSearched] = useState([]);
  const { activeCandidates } = useSelector(myCandidatesSelector);
  const { selectedCandidate, candidateSelectedResume } = useSelector(appSelector);

  const [favLoaded, setFavLoaded] = useState(false);
  const [showMoreSkills, setShowMoreSkills] = useState(false);

  const { user: currentUser } = useSelector(userSelector);

  const navigate = useNavigate();
  const contextObject = useContext(ResumeContext);
  const { runAdvancedOptimise, analysing: advancedAnalysing, error: advancedError, clearError: clearAdvancedError } = useAdvancedOptimise();

  //console.log("selectedCandidate", selectedCandidate);


 // console.log("currentUser", currentUser)

  const resolveMainTab = () => {
    if (tabView === "Interested" || activeCandidateTab === 1) return "Interested";
    if (tabView === "Submission" || activeCandidateTab === 2) return "Submission";
    if (tabView === "Jobs" || activeCandidateTab === 0 || activeCandidateTab === "jobstab") {
      return "Jobs";
    }
    return "Jobs";
  };

  const currentMainTab = resolveMainTab();

  // Function to get the correct job based on current tab and selected submission
  const getCurrentJob = () => {
    if (currentMainTab === "Submission") {
      // Always use selectedSubmission if set and valid
      if (selectedSubmission && selectedSubmission.job_id) {
        return selectedSubmission;
      } else if (candidateSubmissions && candidateSubmissions.length > 0) {
        // Fallback to first valid submission
        return candidateSubmissions[0];
      }
    } else if (currentMainTab === "Interested") {
      if (candidateInterestedJobs && candidateInterestedJobs.length > 0) {
        return candidateInterestedJobs[0];
      }
    } else if (currentMainTab === "Jobs") {
      if (candidateJobs && candidateJobs.length > 0) {
        return candidateJobs[0];
      }
    } else {
      if (candidateInterestedJobs && candidateInterestedJobs.length > 0) {
        return candidateInterestedJobs[0];
      }
      if (candidateSubmissions && candidateSubmissions.length > 0) {
        return candidateSubmissions[0];
      }
      if (candidateJobs && candidateJobs.length > 0) {
        return candidateJobs[0];
      }
    }
    return null;
  };

  // Automatically load job details based on current tab and selected submission
  useEffect(() => {
    const currentJob = getCurrentJob();
    if (currentJob) {
      // For submissions, use job_id; for other tabs, use id
      const jobId = currentMainTab === "Submission" ? currentJob?.job_id : currentJob?.id;
      // Only fetch if jobDetails is missing or does not match the current job
      if (jobId && (!jobDetails || jobDetails?.id !== jobId)) {
        //dispatch(getJobDetailsAction(jobId));
      }
    }
  }, [candidateJobs, candidateSubmissions, candidateInterestedJobs, tabView, selectedSubmission, dispatch, candidateDetails?.candidate_id]);

  // Reset showMoreSkills when the job changes
  useEffect(() => {
    setShowMoreSkills(false);
  }, [jobDetails?.id]);

  // Check if there's any data available for the current tab
  const hasDataForCurrentTab = () => {
    if (currentMainTab === "Submission") {
      return candidateSubmissions?.length > 0;
    }
    if (currentMainTab === "Interested") {
      return candidateInterestedJobs?.length > 0;
    }
    if (currentMainTab === "Jobs") {
      return candidateJobs?.length > 0;
    }
    return (
      (candidateInterestedJobs?.length || 0) > 0 ||
      (candidateSubmissions?.length || 0) > 0 ||
      (candidateJobs?.length || 0) > 0
    );
  };

  // Check if we should show job details based on current selection
  const shouldShowJobDetails = () => {
    const currentJob = getCurrentJob();
    return currentJob && jobDetails && Object.keys(jobDetails).length > 0;
  };

  const isPanelLoading = (() => {
    if (currentMainTab === "Interested") {
      return (
        candidateDetailLoading ||
        candidateInterestedJobsLoading ||
        (candidateInterestedJobs?.length > 0 && jobDetailsLoading)
      );
    }
    if (currentMainTab === "Submission") {
      const hasSubmissions =
        candidateSubmissions?.length > 0 ||
        Boolean(selectedSubmission?.submission_id || selectedSubmission?.id || selectedSubmission?.job_id);
      return candidateDetailLoading || (hasSubmissions && jobDetailsLoading);
    }
    return candidateDetailLoading || candidateJobsLoading || jobDetailsLoading;
  })();
  const paperStyles = {
    borderRadius: "8px",
    height: "calc(100vh - 160px)",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden"
  };
  const handleClickOpen = () => {
    setFav(true);
    getFavCompanies();
  };
  const formatCompanyName = (name) => {
    if (!name) return "";
    return name
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const handlefavClose = () => {
    setFav(false);
    setSearch("");
  };

  const handleCheckboxChange = (company) => {
    if (selectedCompanies?.includes(company)) {
      setSelectedCompanies(
        selectedCompanies.filter((item) => item?.id !== company?.id)
      );
    } else {
      setSelectedCompanies([...selectedCompanies, company]);
    }
  };

  const handleSubmit = () => {
    // Do something with selectedCompanies
    // alert(`Selected Companies: ${selectedCompanies.map(company => company.name).join(' OR ')}`);
    setCompanyName(
      `(${selectedCompanies
        .map((company) => `"${company.name}"`)
        .join(" OR ")})`
    );
    setFav(false); // Close dialog after submission
  };



  const handlesourcelinkClick = (jobLink) => {
    if (jobLink) {
      // Open the jobLink in a new tab
      window.open(jobLink, '_blank');
    } else {
      console.error("Job link is not available");
      alert("Job link is not available");
    }
  };

  /* copy job detailsview started*/
  const handleCopy = () => {
    const copyText = generateCopyText(); // Implement this function to generate the text to copy
    if (copyText) {
      navigator.clipboard.writeText(copyText)
        .then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 1500); // Reset copied state after 1.5 seconds
        })
        .catch((error) => console.error('Failed to copy:', error));
    }
  };

  const generateCopyText = () => {
    // Implement logic to generate the text to be copied
    let copyText = '';
    if (jobDetails) {
      copyText += `${jobDetails.jobtitle}\n`;
      copyText += `${jobDetails.company_name}\n`;
      copyText += `${jobDetails.location ? jobDetails.location : (parseInt(jobDetails.remote) === 1 ? "Remote" : "N/A")}\n`;
      copyText += `${jobDetails.posted_date !== undefined ? moment(jobDetails.posted_date).fromNow() : moment("2022-03-31T06:26:04.138Z").fromNow()}\n`;
      copyText += `Job Type: ${jobDetails.jobtype_name !== undefined && jobDetails.jobtype_name !== null ? jobDetails.jobtype_name : "Full Time"}\n`;
      copyText += `Visa Type: ${jobDetails.visatypeName !== undefined && jobDetails.visatypeName !== null ? jobDetails.visatypeName : "N/A"}\n`;
      copyText += `Qualifications: ${jobDetails.qualifications !== undefined && jobDetails.qualifications !== null && jobDetails.qualifications !== "" ? jobDetails.qualifications : "N/A"}\n`;
      if (jobDetails.experience != null && String(jobDetails.experience).trim() !== "") {
        copyText += `Experience: ${String(jobDetails.experience).trim() === "0" ? "0 - 3 Years" : jobDetails.experience}\n`;
      }
      copyText += `Required Skills: ${jobDetails.required_skills ? jobDetails.required_skills : "N/A"}\n`;
      copyText += `Job Description: ${jobDetails.job_description !== null && jobDetails.job_description !== undefined && jobDetails.job_description ? jobDetails.job_description.replace(/<[^>]+>/g, "") : ""}\n`;
    }
    return copyText;
  };

  const getFavCompanies = (favid) => {
    setFavLoaded(false);
    fetch(`${Key.domain}/common/getFavourites`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        uid: user?.id,
        favid: favid ? favid : 0,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((resdata) => {
        setFavLoaded(true);
        setFavoriteCompanies(resdata.data);
        setFavoriteCompaniesSearched(resdata.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const makeContextEmpty = () => {
    if (contextObject) {
      contextObject.updateJobTitle?.("");
      contextObject.updateEmail?.("");
      contextObject.updatePhone?.("");
      contextObject.updateExperience?.("");
      contextObject.updateFinish?.(false);
      contextObject.updateFinishOne?.(false);
      contextObject.updateSummary?.("");
      contextObject.updateAISkills?.([]);
    }
  };

  const HandleOptimiseRedirection = async () => {
    makeContextEmpty();

    let resumeId = selectedCandidate?.primary_resume_id || selectedCandidate?.resume_id || candidateDetails?.primary_resume_id || candidateDetails?.resume_id || candidateSelectedResume?.resume_id || candidateResumesList?.[0]?.resume_id || candidateResumesList?.[0]?.id || selectedCandidate?.id;

    if (!resumeId && (selectedCandidate?.candidate_id || candidateDetails?.candidate_id)) {
      try {
        const candidateId = selectedCandidate?.candidate_id || candidateDetails?.candidate_id;
        const response = await axios.post(`${Key.domain}/common/get_candidate_resumes_list`, {
          candidate_id: candidateId,
          user_id: user?.id,
        });
        if (response.data?.data?.length > 0) {
          const resumes = response.data.data;
          const primaryResume = resumes.find(r => r.isPrimary === 1) || resumes[0];
          resumeId = primaryResume.resume_id;
        }
      } catch (err) {
        console.error("Error fetching resumes for fallback", err);
      }
    }

    if (!resumeId) {
      console.error("Resume ID not found. Cannot redirect.");
      alert("Resume ID not found. Please upload a resume first.");
      return;
    }

    navigate(`/resume/optimise/resume_${resumeId}`);
  };

  const HandleAdvancedOptimiseRedirection = async () => {
    let resumeId = selectedCandidate?.primary_resume_id || selectedCandidate?.resume_id || candidateDetails?.primary_resume_id || candidateDetails?.resume_id || candidateSelectedResume?.resume_id || candidateResumesList?.[0]?.resume_id || candidateResumesList?.[0]?.id || selectedCandidate?.id;

    if (!resumeId && (selectedCandidate?.candidate_id || candidateDetails?.candidate_id)) {
      try {
        const candidateId = selectedCandidate?.candidate_id || candidateDetails?.candidate_id;
        const response = await axios.post(`${Key.domain}/common/get_candidate_resumes_list`, {
          candidate_id: candidateId,
          user_id: user?.id,
        });
        if (response.data?.data?.length > 0) {
          const resumes = response.data.data;
          const primaryResume = resumes.find(r => r.isPrimary === 1) || resumes[0];
          resumeId = primaryResume.resume_id;
        }
      } catch (err) {
        console.error("Error fetching resumes for fallback", err);
      }
    }

    if (!resumeId) {
      console.error("Resume ID not found. Cannot redirect.");
      alert("Resume ID not found. Please upload a resume first.");
      return;
    }

    runAdvancedOptimise({
      resumeId,
      jobDescription: jobDetails?.job_description,
      jobTitle: jobDetails?.jobtitle,
    });
  };

  return (
    <Paper elevation={2} sx={paperStyles}>
      <AdvancedOptimiseAnalysingDialog open={advancedAnalysing} />
      <Snackbar
        open={Boolean(advancedError)}
        autoHideDuration={6000}
        onClose={clearAdvancedError}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity="error" onClose={clearAdvancedError} sx={{ width: "100%" }}>
          {advancedError}
        </Alert>
      </Snackbar>
      <Toolbar
        sx={{
          minHeight: "48px !important",
          position: "sticky",
          top: 0,
          zIndex: 3,
          bgcolor: "#fff",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: isDesktopLarge
                ? "15px"
                : isDesktopMedium
                  ? "16px"
                  : isDesktopSmall
                    ? "14px"
                    : "13px",
              margin: 0,
            }}
            paragraph
            id="tableTitle"
            component="div"
          >
            Job Details
          </Typography>
          <React.Fragment>
            {/* <Button
              size="small"
              variant="contained"
              onClick={() => {
                handleClickOpen();
                setSelectedCompanies([]);
              }}
              style={{ textTransform: "none", borderRadius: "5px" }}
            >
              <StarIcon style={{ fontSize: "18px", marginLeft: "1px" }} />{" "}
              &nbsp;Companies
            </Button> */}
            <Dialog
              open={fav}
              onClose={handlefavClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              maxWidth="md"
            >
              <DialogTitle id="alert-dialog-title">
                <Box
                  style={{
                    border: "1px solid lightgray",
                    borderRadius: "5px",
                  }}
                >
                  <input
                    type="text"
                    placeholder="Search Favourite Company"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{ fontSize: "15px", width: "70%" }}
                  />
                  {/* <Button variant="contained" size="small"style={{ float: "right" }}>Search</Button> */}
                </Box>
              </DialogTitle>
              <Divider />
              <DialogContent
                style={{
                  padding: "0px",
                  overflowY: "auto",
                  maxHeight: "500px",
                  minHeight: "500px",
                  minWidth: "500px",
                  maxWidth: "500px",
                  scrollbarWidth: "thin",
                }}
                className="custom-scroll-content"
              >
                {(favoriteCompanies.length > 0 && favLoaded) ? (
                  <DialogContentText id="alert-dialog-description">
                    <ul>
                      {favoriteCompanies
                        .filter((company) =>
                          company.name
                            .toLowerCase()
                            .startsWith(search.toLowerCase())
                        )
                        .map((company, index) => (
                          <li
                            key={index}
                            style={{ listStyleType: "none" }}
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={selectedCompanies.includes(
                                    company
                                  )}
                                  onChange={() =>
                                    handleCheckboxChange(company)
                                  }
                                  name={company.name}
                                />
                              }
                              label={
                                <Typography>
                                  {formatCompanyName(company.name)}
                                </Typography>
                              }
                            />
                          </li>
                        ))}
                    </ul>
                  </DialogContentText>
                ) : (
                  <DialogContentText id="alert-dialog-description">
                    {favLoaded ? "No favorite companies found." : "Loading..."}
                  </DialogContentText>
                )}
              </DialogContent>
              <Divider />
              <DialogActions>
                <Button variant="contained" onClick={handleSubmit}>
                  Submit
                </Button>
                <Button variant="outlined" onClick={handlefavClose}>
                  Cancel
                </Button>
              </DialogActions>
            </Dialog>
          </React.Fragment>
        </Box>


      </Toolbar>
      <Divider />
      {activeCandidates.length > 0 ? (
        isPanelLoading ? (
          <JobDetailsSkeleton />
        ) : !hasDataForCurrentTab() ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
            <Typography>No data is available</Typography>
          </Box>
        ) : !shouldShowJobDetails() ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
            <Typography>No job selected</Typography>
          </Box>
        ) : (
          <Box
            sx={{
              flex: 1,
              minHeight: 0,
              overflowY: "scroll",
              position: "relative",
            }}
          >
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Card
                  sx={{ borderRadius: "8px", boxShadow: "none", padding: "10px" }}
                >
                  <Stack direction="column" gap={2}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", width: "100%" }}>
                      <Stack direction="column">
                        <Typography
                          title={jobDetails?.jobtitle}
                          variant={isDesktopLarge ? "h5" : "h6"}
                          sx={{
                            textTransform: "capitalize",
                            fontWeight: 500,
                            fontSize: "20px",
                            marginBottom: "5px"
                          }}
                        >
                          {jobDetails?.jobtitle ? (jobDetails.jobtitle.length > 50 ? `${jobDetails.jobtitle.slice(0, 40)}...` : jobDetails.jobtitle) : "N/A"}
                        </Typography>
                        <Breadcrumbs separator={<Bullet />} aria-label="breadcrumb">
                          <Typography
                            sx={{
                              margin: 0,
                              fontWeight: 400,
                              textTransform: "capitalize",
                              fontSize: isDesktopLarge ? "0.85rem" : "0.75rem",
                            }}
                          >
                            {jobDetails?.company_name ? jobDetails?.company_name : "N/A"}
                          </Typography>
                          <Typography
                            sx={{
                              margin: 0,
                              fontWeight: 400,
                              textTransform: "capitalize",
                              fontSize: isDesktopLarge ? "0.85rem" : "0.75rem",
                            }}
                          >
                            {jobDetails?.location ? jobDetails.location : "Remote"}
                          </Typography>
                          <Typography
                            sx={{
                              margin: 0,
                              color: "#757575",
                              fontWeight: 500,
                              fontSize: isDesktopLarge ? "0.85rem" : "0.75rem",
                            }}
                          >
                            {jobDetails?.posted_date ? moment(jobDetails.posted_date).fromNow() : "N/A"}
                          </Typography>
                        </Breadcrumbs>
                      </Stack>
                      <Box sx={{ display: "flex", gap: 1, alignItems: "center", pt: 0.5 }}>
                        {jobDetails?.job_link !== "" && (
                          <Tooltip title="Job Link">
                            <InsertLinkOutlinedIcon
                              onClick={() => handlesourcelinkClick(jobDetails?.job_link)}
                              sx={{
                                fontSize: "18px",
                                cursor: "pointer",
                                color: "#757575",
                                "&:hover": { color: "primary.main" }
                              }}
                            />
                          </Tooltip>
                        )}
                        <Tooltip title="Copy Details">
                          <ContentCopyIcon
                            onClick={handleCopy}
                            sx={{
                              fontSize: "16px",
                              cursor: "pointer",
                              color: "#406882",
                              "&:hover": { color: "primary.main" }
                            }}
                          />
                        </Tooltip>
                      </Box>
                    </Box>
                    <Stack direction="column" gap={1}>
                      <Box sx={{ display: "flex", gap: "2px", alignItems: "center" }}>
                        <BusinessCenterRounded
                          sx={{
                            height: "18px",
                            width: "18px",
                            color: "#757575",
                            marginRight: "5px",
                          }}
                        />
                        <Typography
                          sx={{
                            margin: 0,
                            fontSize: isDesktopLarge ? "0.85rem" : "0.75rem",
                          }}
                        >
                          {jobDetails?.jobtype_name}
                        </Typography>
                      </Box>
                      {jobDetails?.experience != null &&
                        String(jobDetails.experience).trim() !== "" && (
                          <Box sx={{ display: "flex", gap: "2px", alignItems: "center" }}>
                            <WorkHistoryRounded
                              sx={{
                                height: "18px",
                                width: "18px",
                                color: "#757575",
                                marginRight: "5px",
                              }}
                            />
                            <Typography
                              sx={{
                                margin: 0,
                                fontSize: isDesktopLarge ? "0.85rem" : "0.75rem",
                              }}
                            >
                              {String(jobDetails.experience).trim() === "0"
                                ? "0 - 3 Years"
                                : jobDetails.experience}
                            </Typography>
                          </Box>
                        )}
                      {(() => {
                        const skills = jobDetails?.required_skills
                          ? jobDetails.required_skills
                              .split(",")
                              .map((s) => s.trim())
                              .filter(Boolean)
                          : [];

                        if (skills.length === 0) return null;

                        const displayedSkills = showMoreSkills
                          ? skills
                          : skills.slice(0, 15);

                        return (
                          <Box sx={{ mt: 0.5 }}>
                            <Stack direction="row" alignItems="flex-start" gap={1}>
                              <ChecklistRtlRounded
                                sx={{
                                  height: "20px",
                                  width: "20px",
                                  color: "#757575",
                                  mt: "2px",
                                }}
                              />
                              <Box
                                sx={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 0.5,
                                  width: "100%",
                                }}
                              >
                                {displayedSkills.map((skill, index) => (
                                  <Chip
                                    key={index}
                                    label={skill}
                                    size="small"
                                    variant="outlined"
                                    sx={{
                                      fontSize: isDesktopLarge
                                        ? "0.75rem"
                                        : "0.65rem",
                                      height: "24px",
                                      borderColor: alpha(
                                        theme.palette.primary.main,
                                        0.2
                                      ),
                                      bgcolor: alpha(
                                        theme.palette.primary.main,
                                        0.05
                                      ),
                                      "&:hover": {
                                        bgcolor: alpha(
                                          theme.palette.primary.main,
                                          0.1
                                        ),
                                      },
                                    }}
                                  />
                                ))}
                                {skills.length > 15 && (
                                  <Button
                                    size="small"
                                    onClick={() =>
                                      setShowMoreSkills(!showMoreSkills)
                                    }
                                    sx={{
                                      fontSize: "0.7rem",
                                      textTransform: "none",
                                      minWidth: "auto",
                                      p: "2px 8px",
                                      color: theme.palette.primary.main,
                                      fontWeight: 600,
                                      "&:hover": {
                                        textDecoration: "underline",
                                        bgcolor: "transparent",
                                      },
                                    }}
                                  >
                                    {showMoreSkills
                                      ? "Show Less"
                                      : `+${skills.length - 15} More`}
                                  </Button>
                                )}
                              </Box>
                            </Stack>
                          </Box>
                        );
                      })()}
                    </Stack>

                  </Stack>
                </Card>

                {(currentUser?.companyid === 4854 || currentUser?.companyid === 45721 || currentUser?.companyid === 483370 || currentUser?.companyid === 446766) && (
                  <Box sx={{ display: "flex", justifyContent: "flex-end", pr: 2, mb: 1, gap: 1 }}>
                    <Tooltip title="Optimise Resume">
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={HandleOptimiseRedirection}
                        sx={{
                          textTransform: "none",
                          fontWeight: 600,
                          fontSize: isDesktopLarge ? "0.75rem" : "0.65rem",
                          px: 2,
                          py: 0.6,
                          borderRadius: "20px",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                          transition: "all 0.25s ease",
                          "&:hover": {
                            transform: "translateY(-1px)",
                          },
                        }}
                      >
                        Optimise Resume
                      </Button>
                    </Tooltip>
                    <Button
                      variant="outlined"
                      color="secondary"
                      size="small"
                      onClick={HandleAdvancedOptimiseRedirection}
                      sx={{
                        textTransform: "none",
                        fontWeight: 600,
                        fontSize: isDesktopLarge ? "0.75rem" : "0.65rem",
                        px: 2,
                        py: 0.6,
                        borderRadius: "20px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                        transition: "all 0.25s ease",
                        "&:hover": {
                          transform: "translateY(-1px)",
                        },
                      }}
                    >
                      Advanced Optimise Resume
                      <Tooltip title="Beta version" arrow>
                        <InfoOutlinedIcon
                          sx={{ ml: 0.5, fontSize: 16, cursor: 'help' }}
                        />
                      </Tooltip>
                    </Button>
                  </Box>
                )}
                {jobDetails?.is_direct_contact === 0 && jobDetails?.is_direct_email === 0 && jobDetails?.job_link !== "" &&
                  < Box
                    sx={{
                      display: "flex", justifyContent: "flex-end", pr: 2,
                    }}>
                    <Button
                      component="a"
                      href={jobDetails?.job_link}
                      target="_blank"
                      rel="noopener noreferrer"
                      startIcon={<LaunchIcon sx={{ fontSize: 16 }} />}
                      sx={{
                        textTransform: "none",
                        fontWeight: 600,
                        fontSize: isDesktopLarge ? "0.7rem" : "0.6rem",
                        px: 1.8,
                        py: 0.45,
                        borderRadius: "20px",
                        color: "#1a73e8",
                        backgroundColor: "#e8f0fe",
                        border: "1px solid #1a73e8",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                        transition: "all 0.25s ease",

                        "&:hover": {
                          backgroundColor: "#1a73e8",
                          color: "#ffffff",
                          transform: "translateY(-1px)",
                          textDecoration: "none",
                        },
                      }}
                    >
                      Apply Now
                    </Button>
                  </Box>}
              </Grid>

              <Grid item xs={12}>
                <Card sx={{ boxShadow: "none", padding: "10px" }}>
                  {/* <Typography sx={{ fontWeight: 500 }}>About the job</Typography> */}
                  <Typography
                    sx={{
                      wordBreak: 'break-word',
                      overflowWrap: 'anywhere',
                      whiteSpace: 'pre-line',
                      '& *': {
                        wordBreak: 'break-word !important',
                        overflowWrap: 'anywhere !important',
                        whiteSpace: 'pre-line !important'
                      }
                    }}
                  >
                    {safeParseHTML(jobDetails?.job_description)}</Typography>
                </Card>
              </Grid>
            </Grid>
          </Box>
        )
      ) : (
        <Typography>No data</Typography>
      )}
    </Paper >
  );
};

export default JobDetails;
